/**
 * /vault — COFRE DE SENHAS estilo Tiflux em duas colunas (sem scroll de
 * página; cada coluna rola internamente): lista de cofres (280px) | conteúdo
 * do cofre selecionado (pastas navegáveis + tabela de senhas).
 *
 * Segurança: o segredo NUNCA aparece em listagens nem entra no cache de
 * queries — só cruza a rede no POST reveal (auditado) e vive no estado do
 * dialog aberto ou vai direto pro clipboard.
 */
import { useState } from 'react';
import { VaultToastProvider } from './vault-toast';
import { VaultListPane } from './vault-list-pane';
import { VaultDetailPane } from './vault-detail-pane';

export function VaultPage() {
  const [selectedId, setSelectedId] = useState<number | null>(null);

  return (
    <VaultToastProvider>
      {/* 100dvh − topbar (3rem) − padding do main (2rem) = altura útil. */}
      <div className="flex h-[calc(100dvh-5rem)] min-h-[420px] gap-4">
        <VaultListPane selectedId={selectedId} onSelect={setSelectedId} />
        {/* key: trocar de cofre zera navegação de pastas e busca local. */}
        <VaultDetailPane key={selectedId ?? 'none'} vaultId={selectedId} />
      </div>
    </VaultToastProvider>
  );
}
